
import { PropTypes } from 'prop-types';
const TextAreaField = ({ required = true, name, label, value,placeholder, updateValue,css }) => {
    return (
        <div className={`flex flex-col gap-3  ${css}`}>
             <span className='font-bold flex items-center gap-1'>{label}{
                required && <span className='text-red-500'>{`*`}</span>
                }</span>
            <textarea
                value={value}
                name={name}
                onChange={(e) => updateValue(name,e.target.value)}
                placeholder={placeholder}
                className={`border rounded p-2 border-[#c7c6c6] outline-none focus:outline-none  font-normal `} required={required}>
            </textarea>
        </div>
    )
}
TextAreaField.propTypes = {
    required: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    updateValue: PropTypes.func,
    css: PropTypes.string
}
export default TextAreaField